import { FlagService } from './flag.service';
import { AgeGroupService } from './agegroup.service';
import { ToastService } from './toast.service';
import { ValidationService } from './validation.service';
import { DataService } from './data.service';
import { LoadscreenService } from './loadscreen.service';

export const services: any[] = [FlagService, AgeGroupService, ToastService, ValidationService, DataService, LoadscreenService];

export * from './flag.service';
export * from './agegroup.service';
export * from './toast.service';
export * from './validation.service';
export * from './data.service';
export * from './loadscreen.service';